// All possible segment types in display order
export const SEGMENT_TYPES = ['org', 'object', 'seg_one', 'seg_two', 'seg_three', 'seg_four', 'seg_five', 'seg_six', 'seg_seven', 'seg_eight', 'project'];

/**
 * Get the display name for a segment type based on municipality settings
 * @param {Object} settings - Municipality settings object
 * @param {boolean} settingsLoaded - Whether settings have been loaded
 * @param {string} accessType - The segment type (e.g., 'org', 'object', 'seg_one')
 * @returns {string} The display name for the segment
 */
export const getSegmentName = (settings, settingsLoaded, accessType) => {
  if (!settingsLoaded) return accessType;

  const nameMap = {
    org: settings.org_name || 'Org',
    object: settings.object_name || 'Object',
    seg_one: settings.seg_one_name || 'Seg One',
    seg_two: settings.seg_two_name || 'Seg Two',
    seg_three: settings.seg_three_name || 'Seg Three',
    seg_four: settings.seg_four_name || 'Seg Four',
    seg_five: settings.seg_five_name || 'Seg Five',
    seg_six: settings.seg_six_name || 'Seg Six',
    seg_seven: settings.seg_seven_name || 'Seg Seven',
    seg_eight: settings.seg_eight_name || 'Seg Eight',
    project: settings.project_name || 'Project'
  };

  return nameMap[accessType] || accessType;
};

/**
 * Get the segment value (code) from an account for a given segment type
 * @param {Object} account - Account object
 * @param {string} segmentType - The segment type
 * @returns {string|null} The segment code or null
 */
export const getSegmentValue = (account, segmentType) => {
  return account?.[segmentType]?.code || null;
};
